import React, { useState } from 'react';
import { Grid, InputLabel, MenuItem } from '@mui/material';
import { PrimaryOutlinedButton, PrimaryLightInput, PrimaryLightSelect } from '../../theme/index'
import '../../sass/styles.scss';
import FormControl from '@mui/material/FormControl';
import { useDispatch } from 'react-redux';
import { modalAction } from '../../redux/reducers/Modal';
import { createUserAction } from '../../redux/reducers/Create';

const UserCreate = () => {

    const dispatch = useDispatch();
    const [role, setRole] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [lastname, setLastname] = useState('');
    const [status, setStatus] = useState('');

    const saveData = () => {
        const user = new FormData(),
              dataNames = ["name", "lastname", "email", "password", "role", "status"];

        user.append(dataNames[0], name);
        user.append(dataNames[1], lastname);
        user.append(dataNames[2], email);
        user.append(dataNames[3], password);
        user.append(dataNames[4], role);
        user.append(dataNames[5], status);
        user.append('METHOD', 'POST');

        dispatch(createUserAction(user, dataNames));
        dispatch(modalAction());
    }
    
  return (
    <>
        <Grid item xs={ 10 }>
            <h5 style={{ margin: '0' }}>Usuario / nuevo</h5>
        </Grid>
        <Grid item xs={ 12 }>
            <Grid container sx={{ py: 6 }}>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Role</InputLabel>
                        <PrimaryLightSelect 
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        onChange={ e => setRole(e.target.value) }
                        >
                            <MenuItem value='admin'>Admin</MenuItem>
                            <MenuItem value='receptionist'>Recepcionista</MenuItem>
                        </PrimaryLightSelect>
                    </FormControl>
                </Grid>
                
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Nombre"
                        fullWidth
                        onChange={ e => setName(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Apellido"
                        fullWidth
                        onChange={ e => setLastname(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="E-mail"
                        fullWidth
                        onChange={ e => setEmail(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Password"
                        fullWidth
                        onChange={ e => setPassword(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                        <PrimaryLightSelect 
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        onChange={ e => setStatus(e.target.value) }
                        >
                            <MenuItem value='true'>Activo</MenuItem>
                            <MenuItem value='false'>Inactivo</MenuItem>
                        </PrimaryLightSelect>
                    </FormControl>
                </Grid>
                <Grid item xs={ 12 } sx={{ mt: 5 }} textAlign='end' className='pr-2'>
                    <PrimaryOutlinedButton onClick={ () => saveData() }>Guardar</PrimaryOutlinedButton>
                </Grid>
            </Grid>
        </Grid>
    </>
  )
}

export default UserCreate